import { useMemo } from 'react';

/**
 * Filters an already-fetched list by substring match on given keys, memoized
 * so it only recomputes when the list, query, or keys actually change. Use
 * this for client-side search over data already in frontend state — no extra
 * API call needed.
 */
export function useLocalFilter<T>(
  items: T[],
  query: string,
  keys: Array<keyof T>
): T[] {
  return useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return items;
    return items.filter(item =>
      keys.some(key =>
        String(item[key] ?? '')
          .toLowerCase()
          .includes(q)
      )
    );
  }, [items, query, keys]);
}
